const DOCUMENT_DOCX_FILE_NAME = 'notification.docx';
const DOCUMENT_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const getProcessingRequestFileResponse = res => {
  if (/download-notification-document/.test(res?.config?.url)) {
    const newRes = {
      ...res,
      data: new Blob([res.data], { type: DOCUMENT_DOCX }),
      headers: {
        ...res.headers,
        'content-disposition': String(res.headers['content-disposition'])
          .split('; ')
          .map(item => {
            if (/filename=/.test(item)) {
              return `filename="${DOCUMENT_DOCX_FILE_NAME}"`;
            }

            return item;
          })
          .join('; '),
        'content-type': DOCUMENT_DOCX,
      },
    };

    return newRes;
  }

  return res;
};
